export function StepConfigurationsEmpty() {
  return (
    <div className="flex items-center justify-center py-16">
      <p className="text-sm text-muted-foreground">Não há configurações a serem realizadas</p>
    </div>
  );
}
